export default __webpack_public_path__ + "static/infrastructure-a0a2189aeedc07cc57036603d2f0d6ea.jpg";